module.exports = __webpack_public_path__ + "static/media/copy-alt.4e69a637.svg";